import { NavLink } from 'react-router-dom';
import { 
    LayoutDashboard, 
    Truck, 
    Users,
    Route,
    CalendarClock, 
    ClipboardList, 
    Calendar,
    BarChart3,
    Bell,
    Settings,
    Fuel
} from 'lucide-react';

const navItems = [
    { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/vehicles', icon: Truck, label: 'Armada' },
    { to: '/drivers', icon: Users, label: 'Sopir' },
    { to: '/trips', icon: Route, label: 'Trip Log' },
    { to: '/schedules', icon: CalendarClock, label: 'Jadwal Service' },
    { to: '/work-orders', icon: ClipboardList, label: 'Work Orders' },
    { to: '/calendar', icon: Calendar, label: 'Kalender' },
    { to: '/reports', icon: BarChart3, label: 'Laporan' },
    { to: '/notifications', icon: Bell, label: 'Notifikasi' },
];

export const Sidebar = () => {
    return (
        <aside className="sidebar" data-testid="sidebar">
            <div className="sidebar-header">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-primary rounded-sm flex items-center justify-center">
                        <Fuel className="w-5 h-5 text-primary-foreground" />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold uppercase tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                            Zenith Asset Intelligence
                        </h1>
                        <p className="text-xs text-muted-foreground font-mono uppercase tracking-wider">
                            Armada Solar Industry
                        </p>
                    </div>
                </div>
            </div>
            
            <nav className="sidebar-nav">
                <div className="space-y-1">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.to === '/'}
                            className={({ isActive }) =>
                                isActive ? 'sidebar-link-active' : 'sidebar-link-inactive'
                            }
                            data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                        >
                            <item.icon className="w-5 h-5" />
                            <span>{item.label}</span>
                        </NavLink>
                    ))}
                </div>
            </nav>
            
            <div className="sidebar-footer">
                <NavLink
                    to="/settings"
                    className={({ isActive }) =>
                        isActive ? 'sidebar-link-active' : 'sidebar-link-inactive'
                    }
                    data-testid="nav-settings"
                >
                    <Settings className="w-5 h-5" />
                    <span>Pengaturan</span>
                </NavLink>
            </div>
        </aside>
    );
};
